import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

// Mirrors the agenda cards so the list keeps its height when the real rows replace it.
export const RelanceAgendaSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
    <div className="@container">
        <div
            data-testid="home-task-skeleton"
            aria-hidden="true"
            className="flex flex-col gap-1.5 @relance-row:gap-xs"
        >
            {Array.from({ length: rows }, (_, i) => (
                <div key={i} className="flex flex-col justify-center gap-m @relance-row:flex-row @relance-row:items-center h-21.5 @relance-row:h-13.5 px-l rounded-lg border border-line-card bg-surface-tertiary shadow-card">
                    <div className="flex items-center gap-m h-6 @relance-row:flex-1">
                        <SkeletonBar className="h-3 flex-1" />
                        <SkeletonBar className="h-3 w-20 shrink-0 @relance-row:hidden" />
                    </div>
                    <div className="flex items-center gap-m h-5">
                        <SkeletonBar className="h-5 w-12 shrink-0" />
                        <SkeletonBar className="h-3 w-24 shrink-0" />
                        <SkeletonBar className="h-3 w-20 shrink-0" />
                        <SkeletonBar className="hidden @relance-row:block h-3 w-20 shrink-0" />
                    </div>
                </div>
            ))}
        </div>
    </div>
);
